'use strict';

const SELECTOR = '.s-prose blockquote p';

function get_length_class(str, baseClass, longLength, mediumLength) {

    if (str.innerHTML.length >= longLength) {
        return `${baseClass} ${baseClass}--long`;
    }

    if (str.innerHTML.length >= mediumLength) {
        return `${baseClass} ${baseClass}--medium`;
    }

    return baseClass;
}

(function () {
    const blockquotes = document.querySelectorAll(SELECTOR);

    if (!blockquotes.length) {
        return false;
    }

    [].forEach.call(blockquotes, function (quote) {
        let cssClass = get_length_class(quote, 'quote__text', 150, 30);
        quote.setAttribute('class', cssClass);
    });
}());
